export const languageSelector = (state) => state.language;
export const userSelector = (state) => state.user;
export const globalSelector = (state) => state.all;
export const layerSelector = (state) => state.layers;
